import React from "react";
import "./WorkInProgress.css";

const WorkInProgress = () => {
  return (
    <div>
      <h1>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Modi,
        doloremque.
      </h1>
    </div>
  );
};

export default WorkInProgress;
